import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { RootVariable } from './constant.js';

var useEmptyAppStyle = function useEmptyAppStyle() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.EMPTY_IMAGE_SIZE, '96px'), RootVariable.EMPTY_IMAGE_GAP, '16px'), RootVariable.EMPTY_LABEL_FONT_SIZE, '14px'), RootVariable.EMPTY_LABEL_FONT_WEIGHT, 400), RootVariable.EMPTY_LABEL_GAP, '24px')
  };
};

export { useEmptyAppStyle };
//# sourceMappingURL=Empty.app.style.js.map
